import React, { useEffect, useState, useMemo, useRef } from "react"
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import styles from "./index.module.css";
import stylesBase from "./base.module.css";
import stylesReport from "./report.module.css";

const EMPTY_LINE_DATA = 
 [
  {
    "month": "",
    "lineData": {
      "message_delivered": "",
      "friend_added": "",
      "target_reach": "",
      "broadcast": [
        {
          "id": "",
          "name": "",
          "startDate": "",
          "startTime": "",
          "delivered": "",
          "openCount": "",
          "uniqueClick": ""
        }
      ],
      "coupon": [
        {
          "title": "",
          "status": "",
          "numberOfUse": ""
        }
      ]
    },
    "updatedAt": "",
    "createdAt": ""
  }
]

export default function LineReport() {
    //  const token = JSON.parse(localStorage.getItem("userData"));
     const now = dayjs()
     const {t, i18n} = useTranslation()
     const language = i18n.language
     const [loading, setLoading] = useState(false)
     const [activeTab, setActiveTab] = useState(0)
     const [lineData, setLineData] = useState(EMPTY_LINE_DATA)
     console.log("🚀 ~ LineReport ~ lineData:", lineData)
     const [year, setYear] = useState(now.year())
     const [month, setMonth] = useState(now.month() + 1) 
    //  const [userData, setUserData] = useState()
     const inputRef1 = useRef(null);
     const inputRef3 = useRef(null);
     const inputRef4 = useRef(null);
     const inputRef5 = useRef(null);
     const inputRef6 = useRef(null);
     const inputRef7= useRef(null);
     const inputRef8= useRef(null);
     const inputRef9 = useRef(null);

    
  const updateData = (field, value) => {
    setLineData(prev => {
      const current = prev[0] || EMPTY_LINE_DATA[0]
      return [
        {
          ...current,
          lineData: {
            ...current.lineData,
            [field]: value
          }
        }
      ]
    })
  }

  const updateBroadcast = (index, key, value) => {
    setLineData(prev => {
      const current = prev[0] || EMPTY_LINE_DATA[0]
      const broadcast = Array.isArray(current.lineData.broadcast)
        ? current.lineData.broadcast
        : []

      const newBroadcast = broadcast.map((item, idx) =>
        idx === index ? { ...item, [key]: value } : item
      )

      return [
        {
          ...current,
          lineData: {
            ...current.lineData,
            broadcast: newBroadcast
          }
        }
      ]
    })
  }

  const updateCoupon = (index, key, value) => {
    setLineData(prev => {
      const current = prev[0] || EMPTY_LINE_DATA[0]
      const coupon = Array.isArray(current.lineData.coupon)
        ? current.lineData.coupon
        : []

      const newCoupons = coupon.map((item, idx) =>
        idx === index ? { ...item, [key]: value } : item
      )

      return [
        {
          ...current,
          lineData: {
            ...current.lineData,
            coupon: newCoupons
          }
        }
      ]
    })
  }

  const addBroadcast = () => {
    setLineData(prev => {
      const current = prev[0] || EMPTY_LINE_DATA[0]
      const broadcast = Array.isArray(current.lineData.broadcast)
        ? current.lineData.broadcast
        : []

      return [
        {
          ...current,
          lineData: {
            ...current.lineData,
            broadcast: [
              ...broadcast,
              {
                id: "",
                name: "",
                startDate: "",
                startTime: "",
                delivered: "",
                openCount: "",
                uniqueClick: ""
              }
            ]
          }
        }
      ]
    })
  }

  const removeBroadcast = (index) => {
    setLineData(prev => {
      const current = prev[0] || EMPTY_LINE_DATA[0]
      const broadcast = Array.isArray(current.lineData.broadcast)
        ? current.lineData.broadcast
        : []

      return [
        {
          ...current,
          lineData: {
            ...current.lineData,
            broadcast: broadcast.filter((_, i) => i !== index)
          }
        }
      ]
    })
  }

  const addCoupon = () => {
    setLineData(prev => {
      const current = prev[0] || EMPTY_LINE_DATA[0]
      const coupon = Array.isArray(current.lineData.coupon)
        ? current.lineData.coupon
        : []

      return [
        {
          ...current,
          lineData: {
            ...current.lineData,
            coupon: [
              ...coupon,
              { title: "", status: "", numberOfUse: "" }
            ]
          }
        }
      ]
    })
  }

  const removeCoupon = (index) => {
    setLineData(prev => {
      const current = prev[0] || EMPTY_LINE_DATA[0]
      const coupon = Array.isArray(current.lineData.coupon)
        ? current.lineData.coupon
        : []

      return [
        {
          ...current,
          lineData: {
            ...current.lineData,
            coupon: coupon.filter((_, i) => i !== index)
          }
        }
      ]
    })
  }
    const handleKeyDown = (e, ref) => {
    const input = ref.current;    
    const { selectionStart, selectionEnd } = input;

    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      // Move cursor left
      if (selectionStart > 0) {
        input.setSelectionRange(selectionStart - 1, selectionStart - 1);
      }
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      // Move cursor right
      if (selectionEnd < input.value.length) {
        input.setSelectionRange(selectionStart + 1, selectionStart + 1);
      }
    }
  }

  const getLineData = async () => {
          setLoading(true)
          try {
            const response = await fetch(`/api/control/235f1fd3-af1f-4959-a06b-40b6320ee501/${year}-${String(month).padStart(2, "0")}`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
            
            });
            
            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText);
            }
            const responseData = await response.json();
            setLineData(Array.isArray(responseData) ? responseData : [responseData])
          } 
          catch (error) {
            console.error('Error:', error);
            setLineData(EMPTY_LINE_DATA);
          } finally {
            setLoading(false)
          }
      }
  useEffect(() => {
       getLineData()
      },[month, year])

 

const dataReport = useMemo(() => { 
  return {
    user: 'admin',
    month: `${year}-${String(month).padStart(2, "0")}`,
    lineData: lineData[0]?.lineData ?? EMPTY_LINE_DATA[0].lineData
  }
}, [month, year, lineData])

    const submitLineReport = async (data) => {
          setLoading(true)
          try {
            const response = await fetch(`/api/control/cb0b679d-14b2-4131-a90e-a1eb2afbe6b7`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              // 'Authorization': token.token
            },
            body: JSON.stringify(data)
            
            });
            
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            const responseData = await response.json();
            alert(responseData.msg)
          } 
          catch (error) {
            console.error('Error:', error);
          } finally {
            setLoading(false)
          }
      }
  
    return (
      <div className="ml-5 mr-5" style={{
        borderRadius: 6,
        overflow: "auto"
      }}>
        <div style={{fontSize: 40, fontWeight: 'bold'}}>Make Line Report</div>
        {/* <div>userId: {userData?.data?.userId}</div> */}
        <div className="container" style={{border:'1px solid #000', padding: 10}}>
         <div className="d-flex" style={{marginRight: 10, width: 'fit-content'}}>
                <select className={styles.contentBookingBranchSelect} style={{marginRight: 10}} value={year} onChange={(e) => setYear(Number(e.target.value))}>
                {[2024, 2025, 2026, 2027].map(y => (
                  <option key={y} value={y}>{y}</option>
                ))}
              </select>
             <select
              className={styles.contentBookingBranchSelect}
              value={month}
              onChange={(e) => setMonth(Number(e.target.value))}
            >
              {Array.from({ length: 12 }).map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  Tháng {i + 1}
                </option>
              ))}
            </select>
          
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div style={{fontSize: 20, fontWeight: 'bold', marginLeft: 5, marginTop: 20, backgroundColor: "#482979", width:'fit-content', color: "#fff", padding: 10, borderRadius: 10}}>General</div>
               <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 160}}>
                        Message Delivered
                       </div>
                       <input
                        ref={inputRef1}
                        onKeyDown={(e) => handleKeyDown(e, inputRef1)}
                        placeholder="Message Delivered"
                        type="text"
                        value={lineData[0]?.lineData?.message_delivered}
                        className={`${stylesBase.formContent} mb-0`}
                        onChange={(e) => updateData('message_delivered', e.target.value.replace(/\D/g, ''))}
                      />
                        </div>
          </div>
           <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 160}}>
                        Friend Added
                       </div>
                       <input
                        ref={inputRef1}
                        onKeyDown={(e) => handleKeyDown(e, inputRef1)}
                        placeholder="Friend Added"
                        type="text"
                        value={lineData[0]?.lineData?.friend_added}
                        className={`${stylesBase.formContent} mb-0`}
                         onChange={(e) => updateData('friend_added', e.target.value.replace(/\D/g, ''))}
                      />
                        </div>
          </div>
           <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 160}}>
                        Target Reach
                       </div>
                       <input
                        ref={inputRef3}
                        onKeyDown={(e) => handleKeyDown(e, inputRef3)}
                        placeholder="Target Reach"
                        type="text"
                        value={lineData[0]?.lineData?.target_reach}
                        className={`${stylesBase.formContent} mb-0`}
                         onChange={(e) => updateData('target_reach', e.target.value.replace(/\D/g, ''))}
                      />
                        </div>
          </div>
          </div>
          <div className="col-md-4">
            <div style={{fontSize: 20, fontWeight: 'bold', marginLeft: 5, marginTop: 20, backgroundColor: "#482979", width:'fit-content', color: "#fff", padding: 10, borderRadius: 10}}>Broadcast</div>
            {(lineData[0]?.lineData?.broadcast ?? []).map((item, index) => (
              <div
                key={index}
                style={{
                  border: "1px dashed #ccc",
                  borderRadius: 10,
                  padding: 15,
                  marginTop: 20
                }}
              >
          <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 160}}>
                       ID
                       </div>
                       <input
                        ref={inputRef4}
                        onKeyDown={(e) => handleKeyDown(e, inputRef4)}
                        placeholder="Broadcast ID"
                        type="text"
                        value={item.id}
                        className={`${stylesBase.formContent} mb-0`}
                         onChange={(e) => updateBroadcast(index,'id', e.target.value)}
                      />
                        </div>
          </div>
          <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 160}}>
                        Name
                       </div>
                       <input
                        ref={inputRef5}
                        onKeyDown={(e) => handleKeyDown(e, inputRef5)}
                        placeholder="Broadcast Name"
                        type="text"
                        value={item.name}
                        className={`${stylesBase.formContent} mb-0`}
                         onChange={(e) => updateBroadcast(index,'name', e.target.value)}
                      />
                        </div>
          </div>
           <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 85}}>
                        Date Start
                       </div>
                       <input
                        ref={inputRef6}
                        onKeyDown={(e) => handleKeyDown(e, inputRef6)}
                        placeholder="Broadcast Start From"
                        type="date"
                        value={item.startDate}
                        className={`${stylesBase.formContent} mb-0`}
                         onChange={(e) => updateBroadcast(index,'startDate', e.target.value)}
                        style={{width: 208}}
                      />
                        </div>
          </div>
           <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 85}}>
                        Time Start
                       </div>
                       <input
                        ref={inputRef7}
                        onKeyDown={(e) => handleKeyDown(e, inputRef7)}
                        placeholder="Broadcast Time Start"
                        type="time"
                        value={item.startTime}
                        className={`${stylesBase.formContent} mb-0`}
                        onChange={(e) => updateBroadcast(index,'startTime', e.target.value)}
                        style={{width: 208}}
                      />
                        </div>
          </div>
            <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 160}}>
                        Delivered
                       </div>
                       <input
                        ref={inputRef8}
                        onKeyDown={(e) => handleKeyDown(e, inputRef8)}
                        placeholder="Broadcast Delivered"
                        type="text"
                        value={item.delivered}
                        className={`${stylesBase.formContent} mb-0`}
                         onChange={(e) => updateBroadcast(index,'delivered', e.target.value.replace(/\D/g, ''))}
                      />
                        </div>
          </div>
            
           <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 160}}>
                        Open Count
                       </div>
                       <input
                        ref={inputRef9}
                        onKeyDown={(e) => handleKeyDown(e, inputRef9)}
                        placeholder="Broadcast Open Count"
                        type="text"
                        value={item.openCount}
                        className={`${stylesBase.formContent} mb-0`}
                         onChange={(e) => updateBroadcast(index,'openCount', e.target.value.replace(/\D/g, ''))}
                      />
                        </div>
          </div>
            
           <div className={stylesReport.inputData}>
             <div className="d-flex align-items-center mt-5">
                       <div className={stylesReport.nameTitle} style={{width: 160}}>
                        Unique Click
                       </div>
                       <input
                        ref={inputRef9}
                        onKeyDown={(e) => handleKeyDown(e, inputRef9)}
                        placeholder="Broadcast Unique Click"
                        type="text"
                        value={item.uniqueClick}
                        className={`${stylesBase.formContent} mb-0`}
                         onChange={(e) => updateBroadcast(index,'uniqueClick', e.target.value.replace(/\D/g, ''))}
                      />
                        </div>
          </div>
          {lineData[0]?.lineData?.broadcast?.length > 1 && (
        <button
          onClick={() => removeBroadcast(index)}
          style={{
            marginTop: 10,
            background: "#dc3545",
            color: "#fff",
            border: "none",
            padding: "5px 10px",
            borderRadius: 5
          }}
        >
          Delete Broadcast
        </button>
          )}
              </div>
            ))}
   {/* ADD BUTTON */}
        <button
          onClick={addBroadcast}
          style={{
            marginTop: 20,
            background: "#482979",
            color: "#fff",
            border: "none",
            padding: "10px 15px",
            borderRadius: 8
          }}
        >
          + Add Broadcast
        </button>
        </div>
        
         <div className="col-md-4">
        <div
          style={{
            fontSize: 20,
            fontWeight: "bold",
            marginLeft: 5,
            marginTop: 20,
            backgroundColor: "#482979",
            width: "fit-content",
            color: "#fff",
            padding: 10,
            borderRadius: 10
          }}
        >
          Coupon
        </div>

  {(lineData[0]?.lineData?.coupon ?? []).map((item, index) => (
    <div
      key={index}
      style={{
        border: "1px dashed #ccc",
        borderRadius: 10,
        padding: 15,
        marginTop: 20
      }}
    >
      <div className={stylesReport.inputData}>
        <div className="d-flex align-items-center mt-3">
          <div className={stylesReport.nameTitle} style={{ width: 160 }}>
            Title
          </div>
          <input
            placeholder="Coupon Title"
            type="text"
            value={item.title}
            className={`${stylesBase.formContent} mb-0`}
            onChange={(e) =>
              updateCoupon(index, "title", e.target.value)
            }
          />
        </div>
      </div>

      <div className={stylesReport.inputData}>
        <div className="d-flex align-items-center mt-3">
          <div className={stylesReport.nameTitle} style={{ width: 78 }}>
            Status
          </div>
          {/* <input
            placeholder="Coupon Status"
            type="text"
            value={item.status}
            className={`${stylesBase.formContent} mb-0`}
            onChange={(e) =>
              updateCoupon(index, "status", e.target.value)
            }
          /> */}
          <select className={`${stylesBase.formContent} m-0`} style={{width: 195}} onChange={(e) => updateCoupon(index, "status", e.target.value)}>
             <option value="" >Coupon Status</option>
            <option value="Expired ">Expired</option>
            <option value="Valid">Valid</option>
            <option value="Discontinued">Discontinued</option>
          </select>
        </div>
      </div>

      {/* NUMBER OF USE */}
      <div className={stylesReport.inputData}>
        <div className="d-flex align-items-center mt-3">
          <div className={stylesReport.nameTitle} style={{ width: 160 }}>
            Number of Use
          </div>
          <input
            placeholder="Number of Use"
            type="text"
            value={item.numberOfUse}
            className={`${stylesBase.formContent} mb-0`}
            onChange={(e) =>
              updateCoupon(
                index,
                "numberOfUse",
                e.target.value.replace(/\D/g, "")
              )
            }
          />
        </div>
      </div>

      {/* REMOVE BUTTON */}
      {lineData[0]?.lineData?.coupon?.length > 1 && (
        <button
          onClick={() => removeCoupon(index)}
          style={{
            marginTop: 10,
            background: "#dc3545",
            color: "#fff",
            border: "none",
            padding: "5px 10px",
            borderRadius: 5
          }}
        >
          Xoá Coupon
        </button>
      )}
    </div>
  ))}

  {/* ADD BUTTON */}
  <button
    onClick={addCoupon}
    style={{
      marginTop: 20,
      background: "#482979",
      color: "#fff",
      border: "none",
      padding: "10px 15px",
      borderRadius: 8
    }}
  >
    + Thêm Coupon
  </button>
</div>

        </div>
        </div>
           <div className="d-flex justify-content-center">
              <div style={{marginRight: 10, width: 'fit-content'}}>
            <button className={stylesBase.baseBtn} style={{width: 200, borderRadius: 20}} onClick={() => {
              if (lineData?.[0]?.lineData) {
                submitLineReport(dataReport)
              } else {
                alert("Please fill in the data")
              }
              }}>Save</button>
            </div>
      </div>
   </div>
  </div>
  );
}



